module.exports = __webpack_public_path__ + "static/media/C1.66d13135.png";